// extracted by mini-css-extract-plugin
module.exports = {"body":"progress-modal-all-stages_body__QlBCM","header":"progress-modal-all-stages_header__EAA3t","button":"progress-modal-all-stages_button__pR9Al"};